import { render, staticRenderFns } from "./FourFiveDigitModeSwitch.vue?vue&type=template&id=3559a31b&scoped=true&"
import script from "./FourFiveDigitModeSwitch.vue?vue&type=script&lang=js&"
export * from "./FourFiveDigitModeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./FourFiveDigitModeSwitch.vue?vue&type=style&index=0&id=3559a31b&lang=scss&scoped=true&"
import style1 from "./FourFiveDigitModeSwitch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3559a31b",
  null
  
)

export default component.exports